<template>
  <b-modal
    :id="identifierModal"
    ref="selectable_config_modal"
    title="Command Config"
    @show="onShow"
    @hidden="onHidden"
    hide-header
    centered
    no-close-on-esc
    no-close-on-backdrop
    scrollable
  >
    <p class="h3 mb-0">{{ $t('commands.selectable.modal_title') }}</p>
    <hr class="mb-2" />
    <validation-provider
      :name="$t('commands.selectable.type_field')"
      rules="required"
      v-slot="{ errors }"
    >
      <label class="d-block">
        {{ $t('commands.selectable.type_field') }}
      </label>
      <v-select
        :options="fieldTypes"
        v-model="fieldTypeProxy"
        clearable
        input-id="field-type"
        placeholder="Seleccionar"
        append-to-body
        :calculate-position="withPopper"
        @input="buildFieldData"
      />
      <p v-if="errors" class="small text-danger">
        {{ errors[0] }}
      </p>
    </validation-provider>
    <hr v-if="draftFieldType">
    <component
      v-if="draftFieldType"
      :field-data="draftFieldData"
      :is="fieldTypesComponents[draftFieldType]"
      :ref="`ref${draftFieldType}`"
    />
    <template #modal-footer="{ close }">
      <div class="">
        <b-button
          variant="danger"
          size="sm"
          class="float-left mr-1"
          @click="close()"
        >
          {{ $t("commands.modal.btns.cancel") }}
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          class="float-right"
          @click="onContinueClick(close)"
        >
          {{ $t("commands.modal.btns.continue") }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import OptionsField from './OptionsField.vue';
import InputField from './InputField.vue';
import vSelect from "vue-select";
import { ValidationProvider } from "vee-validate";
import popperHelper from '@/libs/popper-helper'

export default {
  props: {
    fieldData: {
      type: Object
    },
    fieldType: {
      type: String
    },
    fieldTypes: {
      type: Array
    },
    idModal: {
      type: String
    }
  },
  components:{
    InputField,
    OptionsField,
    vSelect,
    ValidationProvider
  },
  data() {
    return {
      fieldTypesComponents: {
        'Checkbox': OptionsField,
        'Input': InputField,
        'Select': OptionsField,
        'Textarea': InputField
      },
      withPopper: popperHelper.withPopper,
      draftFieldData: {},
      draftFieldType: null,
    }
  },
  computed:{
    identifierModal() {
      return `selectable-config-modal-${this.idModal}`
    },
    fieldTypeProxy: {
      get() {
        return this.draftFieldType;
      },
      set(value) {
        this.draftFieldType = value;
        this.draftFieldData.type = value;
        if (value === 'Input' || value === 'Textarea') {
          this.draftFieldData.options = [];
        }
      }
    }
  },
  methods: {
    buildFieldData(fieldType) {
      this.fieldTypeProxy = fieldType;
    },
    async onContinueClick(close) {
      const refCurrentComponent = `ref${this.draftFieldType}`;
      const currentComponent    = this.$refs[refCurrentComponent];
      if (!currentComponent) return;
      const successValidation   = await currentComponent.$refs.refFormObserver.validate();

      if (!successValidation) {
        return
      }

      if (this.draftFieldData.type === 'Input' || (this.draftFieldData.type === 'Textarea')) {
        this.$emit('show-preview', JSON.parse(JSON.stringify(this.draftFieldData)));
        close();
        return
      }

      currentComponent.setErrorOptions(false);

      if (!this.draftFieldData.options.length) {
        currentComponent.setErrorOptions(true);
        return
      }

      this.$emit('show-preview', JSON.parse(JSON.stringify(this.draftFieldData)));
      close();
    },
    onShow() {
      this.draftFieldData = JSON.parse(JSON.stringify(this.fieldData || {
        type: null,
        name: null,
        options: [],
        rules: null,
      }));
      this.draftFieldType = this.draftFieldData.type || this.fieldType;
    },
    onHidden() {
      this.draftFieldData = {};
      this.draftFieldType = null;
    }
  }
}
</script>
